import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import BaseComponent from 'foundation/base-component';
import store from 'general/js/store';
import LiveWidgetPosts from './live-widget-posts';
import { LiveWidgetEmbeddedContent } from './live-widget-embedded-content';

class LiveWidgetComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        if (this.refs.embeddedContent) {
            ReactDOM.render(
                <Provider store={store}>
                    <LiveWidgetEmbeddedContent options={this.options.embeddedContent} />
                </Provider>,
                this.refs.embeddedContent
            );
        }
        if (this.refs.liveText) {
            ReactDOM.render(
                <Provider store={store}>
                    <LiveWidgetPosts options={this.options.text} />
                </Provider>,
                this.refs.liveText
            );
        }
    }
}

export default LiveWidgetComponent;
